module.exports = __webpack_public_path__ + "img/vaccines.b58dc642.svg";